import React, { FC } from 'react';

import { Loader } from '@crehana/ui';

import { Reload2 } from '@crehana/icons';

import { STEPS_DATA } from '../utils';

import Step from './Step';

interface Props {
  loading: boolean;
  reloadQr: () => void;
  qr: string;
}

const QrScreen: FC<Props> = ({ loading, reloadQr, qr }) => {
  const renderQr = () =>
    qr ? (
      <img width="100%" src={qr} alt="Código QR" />
    ) : (
      <button type="button" onClick={reloadQr} title="reload">
        <Reload2 size={48} />
      </button>
    );

  return (
    <article className="flex flex-col items-center">
      <header className="mb-24">
        <h2 className="font-h4">Escanea el QR desde tu app</h2>
      </header>
      <div className="mb-40 w-212 h-212 shadow-4-dp flex items-center justify-center bg-white p-8">
        {loading ? (
          <div role="status">
            <Loader size={48} />
          </div>
        ) : (
          renderQr()
        )}
      </div>
      <ol className="flex flex-col md:flex-row w-full md:mb-40">
        {STEPS_DATA.map((step, index) => {
          const { image, text, textWidth } = step;

          return (
            <Step
              key={`step-${index + 1}`}
              image={image}
              number={index + 1}
              text={text}
              textWidth={textWidth}
            />
          );
        })}
      </ol>
      <footer className="px-20 py-16 bg-gray-light rounded-5">
        <p className="text-center font-legals text-base-main">
          Recuerda que una vez hayas pagado desde Yape, se te enviará un correo
          de confirmación de tu compra.
        </p>
      </footer>
    </article>
  );
};

export default QrScreen;
